import { Component, OnInit, Inject, ViewChild, NgZone } from '@angular/core';
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { AdminService } from '../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';
import { take } from 'rxjs/operators';
import { Petition } from '../../../../../../../shared/admin-models/interfaces/petition.interface';
@Component({
  selector: 'app-agreement-dialog',
  templateUrl: './agreement-dialog.component.html',
  styleUrls: ['./agreement-dialog.component.scss']
})
export class AgreementDialogComponent implements OnInit {
  comment = '';
  constructor(
    public dialogRef: MatDialogRef<AgreementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public petition: Petition,
    private adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _ngZone: NgZone,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {}
  closeDialog() {
    this.dialogRef.close();
  }
  sendAgreement() {
    this._loadingService.register();
    const data = {
      commentary: this.comment,
    };
    if (this.comment.length) {
      this.adminService
        .changeStatusToFinalLegalApprove(data, this.petition.id)
        .subscribe((res) => {
          this._loadingService.resolve();
          this.dialogRef.close('თანხმობა იდეის განხორციელებაზე გაგზავნილია')
        },
        (err) => {
          this._loadingService.resolve()
          this._snackBar.open('დაფიქსირდა შეცდომა',null,{
            duration:2000,
            panelClass:'red-snackbar',
            horizontalPosition:"right",
            verticalPosition:"top"
          })
        });
    }
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/agreement-dialog/agreement-dialog.component.ts